import JSBI from 'jsbi';
import { JettonAmount } from '../entities/JettonAmount';
import { Jetton } from '../entities/Jetton';
import { parseUnits } from '../utils/parseUnits';

export const parseBalance = (value: string, decimals = 18) =>
  parseUnits(value || '0', decimals);

// try to parse a user entered amount for a given token
export function tryParseAmount<T extends Jetton>(
  value?: string,
  currency?: T
): JettonAmount<T> | undefined {
  if (!value || !currency) {
    return undefined;
  }
  try {
    const typedValueParsed = parseUnits(value, currency.decimals).toString();
    if (typedValueParsed !== '0') {
      return JettonAmount.fromRawAmount(
        currency,
        JSBI.BigInt(typedValueParsed)
      );
    }
  } catch (error) {
    // should fail if the user specifies too many decimal places of precision (or maybe exceed max uint?)
    console.debug(`Failed to parse input amount: "${value}"`, error);
  }
  // necessary for all paths to return a value
  return undefined;
}
